module.exports = __webpack_public_path__ + "img/SH2D_300005.d692f9b5.png";